import React from 'react';
import classNames from 'classnames';
import { Text } from '@chakra-ui/react';

import { TabMenuItem } from './TabMenuItem';
import { TabMenuContainer } from './TabMenuContainer';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface TabsMenuProps {
  activeTab: string;
  activeIndex: number;
  tabs: string[];
  className: string;
  onClick: (index: number) => void;
  disabledIndexes: number[];
}

export class TabsMenu extends React.Component<TabsMenuProps> {
  tabMenuRef: any;
  state: { showTabMenu: boolean };
  constructor(props: TabsMenuProps) {
    super(props);
    this.tabMenuRef = React.createRef();
    this.state = {
      showTabMenu: false,
    };
  }

  handleClick = (e: { target: any; }) => {
    if (this.tabMenuRef.current.contains(e.target) && !this.state.showTabMenu) {
      this.setState({ showTabMenu: true });
      return;
    }
    this.setState({ showTabMenu: false });
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false);
  }

  render() {
    const { activeIndex, activeTab, tabs, className, onClick } = this.props;
    const { showTabMenu } = this.state;
    return (
      <div ref={this.tabMenuRef}>
        <TabMenuContainer className={`v-center ${className}`}>
          <Text as="div" textStyle="caption" className="caption tab-caption">
            {activeTab}
          </Text>
          <ChevronDownIcon className="tab-icon" name="ExpandMore" />
          <div
            className={classNames(
              'tab-menu-container',
              { hidden: !showTabMenu },
              { displayed: showTabMenu },
            )}
          >
            <ul>
              {showTabMenu &&
                tabs.map((tab, i) => (
                  <TabMenuItem
                    disabled={this.props.disabledIndexes.includes(i)}
                    activeIndex={activeIndex}
                    tabName={tab}
                    key={i}
                    index={i}
                    onClick={onClick}
                  />
                ))}
            </ul>
          </div>
        </TabMenuContainer>
      </div>
    );
  }
}
